/**
 * バンドルミックスマッチ検索画面　プロモーション商品情報取得VOクラス
 */
export class KYMW1309GetPromotionGoodsInfoModel {
  // 受注コード
  public orderCode: string = <string>'';

  // 媒体区分
  public mediumType: string = <string>'';

  // プロモーションＮＯ
  public promotionNo: string = <string>'';

  // プロモーション区分
  public promotionDiv: string = <string>'';

  // プロモーション名称
  public promotionName: string = <string>'';

  // 生協コード
  public coopCode: string = <string>'';

  // Ｐコード
  public pCode: string = <string>'';

  // 部門コード
  public classCode: string = <string>'';
}
